export default {
  "name": "Vic",
  "motto": "要加油",
  "title": "菜鸡互啄"
}



// WEBPACK FOOTER //
// ./src/config/intro.js